import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/bankaccount',
  component: () => import('@views/BankAccount/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'bankaccount.index',
      component: () => import('@/components/BankAccount/BankAccount')
    },
  ]
}
